import axios from 'axios';

export function fetchData() {
  //axios.get('https://web-{{ apiData?.api_domain }}/v1/admin/whitelabel')
  return axios.get('https://web-api.yup.chat/v1/admin/whitelabel')
    .then(response => response.data)
    .catch(error => {
      console.error('Erro ao buscar os dados:', error);
      throw error;
    });
}